import { Link } from "react-router-dom";

/**
 * e-cell woordmerk — huisstijl 2026
 * Lowercase "e-cell" in Manrope 800; het koppelteken is de actieve
 * lichtkern (rood-wit-blauw) met een korte pulse bij activatie.
 */
export default function Logo({ size = "md", light = false, className = "" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl",
    xl: "text-6xl md:text-8xl",
  };
  return (
    <Link
      to="/"
      className={`group font-display font-extrabold tracking-tight flex items-center ${
        light ? "text-white" : "text-bone"
      } ${sizes[size]} ${className}`}
      data-testid="site-logo"
      aria-label="e-cell — Home"
    >
      <span>e</span>
      <span className="hyphen-core mx-[0.12em]" aria-hidden="true" />
      <span>cell</span>
    </Link>
  );
}
